<template>
  <b-container fluid>
    <b-modal id="modal-login" centered size="lg" @ok="process">
      <template #modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="primary" @click="cancel()">
          {{ $t("public.components.account.LoginModal.btn.cancel") }}
        </b-button>
        <b-button v-if="view === 'REGISTER'" size="sm" variant="success" @click="showLogin">
          {{ $t("public.components.account.LoginModal.btn.login") }}
        </b-button>
        <b-button size="sm" variant="success" @click="ok()">
          <div v-if="view === 'LOGIN'">
            {{ $t("public.components.account.LoginModal.btn.enter") }}
          </div>
          <div v-if="view === 'REGISTER'">
            {{ $t("public.components.account.LoginModal.btn.register") }}
          </div>
        </b-button>
      </template>
      <template #modal-title>
        <div v-if="view === 'LOGIN'">
          {{ $t("public.components.account.LoginModal.btn.login") }}
        </div>
        <div v-if="view === 'REGISTER'">
          {{ $t("public.components.account.LoginModal.btn.register") }}
        </div>
      </template>
      <div v-if="view === 'LOGIN'">
        <b-form-group label-for="email">
          <template slot="label">{{ $t("public.components.account.LoginModal.mail") }}
          </template>
          <b-form-input id="email" v-model="user.email" type="text" v-bind:class="{
            'text-danger': isFormEmailErrors,
            'is-invalid': isFormEmailErrors,
          }" @blur="checkEmail(user.email)"></b-form-input>
          <ul v-if="isFormEmailErrors">
            <li v-for="(error, index) in validator.getErrors('email')" v-bind:key="index" class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>

        <b-form-group label-for="password">
          <template slot="label">{{ $t("public.components.account.LoginModal.password") }}
          </template>
          <b-form-input id="password" v-model="user.password" type="password" v-bind:class="{
            'text-danger': isFormPasswordErrors,
            'is-invalid': isFormPasswordErrors,
          }" @blur="checkPassword(user.password)"></b-form-input>
          <ul v-if="isFormPasswordErrors">
            <li v-for="(error, index) in validator.getErrors('password')" v-bind:key="index"
              class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
        <div class="d-inline-block w-100">
          <b-form-checkbox id="remember" v-model="remember" class="mt-2 pt-1" name="remember" @change="rememberMe">
            {{ $t("public.components.account.LoginModal.remember") }}
          </b-form-checkbox>
        </div>
        <!--
        <div class="sign-info">
          <span class="dark-color d-inline-block line-height-2">
            {{ $t("public.components.account.LoginModal.noAccount") }}
            <a
              @click="showRegister"
              class="
                iq-waves-effect
                pr-4
                title-typography-color-important
                cursor-point
              "
            >{{ $t("public.components.account.LoginModal.register") }}</a>
          </span>
        </div>
        -->
      </div>
      <div v-if="view === 'REGISTER'">
        <form action="#">
          <b-form-group label="Email: *" label-for="email">
            <b-form-input v-model="email1" type="text" v-bind:class="{
              'text-danger': isFormEmail1Errors,
              'is-invalid': isFormEmail1Errors,
            }" @blur="checkEmail1(email1, emailInUse)"></b-form-input>
            <ul v-if="isFormEmail1Errors">
              <li v-for="(error, index) in validatorStep2.getErrors('email')" v-bind:key="index"
                class="form-text text-danger">
                &nbsp;{{ error }}
              </li>
            </ul>
          </b-form-group>
          <b-form-group label-for="name">
            <template slot="label">{{ $t("public.components.account.LoginModal.name") }}:
            </template>
            <b-form-input id="nombre" v-model="name" :disabled="disabled" type="text" v-bind:class="{
              'text-danger': isFormNameErrors,
              'is-invalid': isFormNameErrors,
            }" @blur="checkName(name)"></b-form-input>
            <ul v-if="isFormNameErrors">
              <li v-for="(error, index) in validatorStep2.getErrors('name')" v-bind:key="index"
                class="form-text text-danger">
                &nbsp;{{ error }}
              </li>
            </ul>
          </b-form-group>
          <b-form-group label-for="lastname">
            <template slot="label">{{ $t("public.components.account.LoginModal.lastname") }}:
            </template>
            <b-form-input id="lastname" v-model="lastname" :disabled="disabled" type="text" v-bind:class="{
              'text-danger': isFormLastnameErrors,
              'is-invalid': isFormLastnameErrors,
            }" @blur="checkLastname(lastname)"></b-form-input>
            <ul v-if="isFormLastnameErrors">
              <li v-for="(error, index) in validatorStep2.getErrors('lastname')" v-bind:key="index"
                class="form-text text-danger">
                &nbsp;{{ error }}
              </li>
            </ul>
          </b-form-group>

          <b-form-group label-for="document">
            <template slot="label">{{ $t("public.components.account.LoginModal.document") }}:
            </template>
            <b-form-input id="document" v-model="document" :disabled="disabled" type="text" v-bind:class="{
              'text-danger': isFormDocumentErrors,
              'is-invalid': isFormDocumentErrors,
            }"></b-form-input>
            <ul v-if="isFormDocumentErrors">
              <li v-for="(error, index) in validatorStep2.getErrors('document')" v-bind:key="index"
                class="form-text text-danger">
                &nbsp;{{ error }}
              </li>
            </ul>
          </b-form-group>
          <div class="row">
            <div v-if="!disabled" class="col-md-8">
              <b-form-group>
                <template slot="label">{{
                  $t("public.components.account.LoginModal.image")
                }}:
                </template>
                <vue-dropzone id="picture" :disabled="disabled" :options="dropzoneOptions"
                  @vdropzone-success="vdropzoneSuccess"></vue-dropzone>
              </b-form-group>
            </div>
            <div class="col-md-4 img-center">
              <img v-if="defaultAvatar" :src="file" class="img-fluid rounded mr-3" height="150px" width="150px" />
              <img v-else class="img-fluid rounded mr-3" height="150px" v-bind:src="'data:image/jpeg;base64,' + file"
                width="150px" />
            </div>
          </div>
          <b-form-group label-for="idioma">
            <template slot="label">{{ $t("public.components.account.LoginModal.language") }}:
            </template>
            <b-select id="language" v-model="language" :disabled="disabled" :options="languageSelect"
              class="form-control" v-bind:class="{
                'text-danger': isFormLanguageErrors,
                'is-invalid': isFormLanguageErrors,
              }">
            </b-select>
            <ul v-if="isFormLanguageErrors">
              <li v-for="(error, index) in validatorStep2.getErrors('language')" v-bind:key="index"
                class="form-text text-danger">
                &nbsp;{{ error }}
              </li>
            </ul>
          </b-form-group>
          <b-form-group label-for="phone">
            <template slot="label">{{ $t("public.components.account.LoginModal.phone") }}:
            </template>
            <VuePhoneNumberInput id="phoneVuePhoneNumberInput" v-model="phoneVuePhoneNumberInput" :disabled="disabled"
              :translations="translations" v-bind:class="{
                'text-danger': isFormPhoneErrors,
                'is-invalid': isFormPhoneErrors,
              }" @update="updatePhone" />
            {{ phone }}
            <ul v-if="isFormPhoneErrors">
              <li v-for="(error, index) in validatorStep2.getErrors('phone')" v-bind:key="index"
                class="form-text text-danger">
                &nbsp;{{ error }}
              </li>
            </ul>
          </b-form-group>
          <b-form-group label-for="country">
            <template slot="label">{{ $t("public.components.account.LoginModal.country") }}:
            </template>
            <b-form-input id="country" v-model="country" :disabled="disabled" type="text" v-bind:class="{
              'text-danger': isFormCountryErrors,
              'is-invalid': isFormCountryErrors,
            }"></b-form-input>
            <ul v-if="isFormCountryErrors">
              <li v-for="(error, index) in validatorStep2.getErrors('country')" v-bind:key="index"
                class="form-text text-danger">
                &nbsp;{{ error }}
              </li>
            </ul>
          </b-form-group>
          <b-form-group label-for="address">
            <template slot="label">{{ $t("public.components.account.LoginModal.address") }}:
            </template>
            <b-form-input id="address" v-model="address" :disabled="disabled" type="text"></b-form-input>
          </b-form-group>
          <b-form-group label-for="timeZone">
            <template slot="label">{{ $t("public.components.account.LoginModal.timeZone") }}:
            </template>
            <b-select id="timeZone" v-model="timeZone" :disabled="disabled" :options="timeZoneSelect"
              class="form-control" v-bind:class="{
                'text-danger': isFormTimeZoneErrors,
                'is-invalid': isFormTimeZoneErrors,
              }">
            </b-select>
            <ul v-if="isFormTimeZoneErrors">
              <li v-for="(error, index) in validatorStep2.getErrors('timeZone')" v-bind:key="index"
                class="form-text text-danger">
                &nbsp;{{ error }}
              </li>
            </ul>
          </b-form-group>
        </form>
      </div>
    </b-modal>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import routes from "../../router/index";
import { xray } from "../../config/pluginInit";

import TimeZone from "../../services/timeZone";
import Language from "../../json/Language";

import validator from "vue-m-validator";

import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import authService from "../../services/auth";
import patientService from "../../services/patient";
import utilsService from "../../services/utils";

export default {
  name: "LoginModal",
  mounted() {
    xray.index();
  },
  props: {
    professionalId: {
      default: "",
    },
  },
  computed: {
    //Form step 1
    isFormEmailErrors() {
      let errors = this.validator.getErrors("email");
      return errors && errors.length > 0;
    },
    isFormPasswordErrors() {
      let errors = this.validator.getErrors("password");
      return errors && errors.length > 0;
    },
    //
    isFormEmail1Errors() {
      const RULE_2_REGEXP = new RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
      );
      if (RULE_2_REGEXP.test(this.email1)) {
        this.getCheckEmail(this.email1);
      }
      let errors = this.validatorStep2.getErrors("email");
      return errors && errors.length > 0;
    },
    isFormNameErrors() {
      let errors = this.validatorStep2.getErrors("name");
      return errors && errors.length > 0;
    },
    isFormLastnameErrors() {
      let errors = this.validatorStep2.getErrors("lastname");
      return errors && errors.length > 0;
    },
    isFormDocumentErrors() {
      let errors = this.validatorStep2.getErrors("document");
      return errors && errors.length > 0;
    },
    isFormLanguageErrors() {
      let errors = this.validatorStep2.getErrors("language");
      return errors && errors.length > 0;
    },
    isFormPhoneErrors() {
      let errors = this.validatorStep2.getErrors("phone");
      return errors && errors.length > 0;
    },
    isFormCountryErrors() {
      let errors = this.validatorStep2.getErrors("country");
      return errors && errors.length > 0;
    },
    isFormAddressErrors() {
      let errors = this.validatorStep2.getErrors("address");
      return errors && errors.length > 0;
    },
    isFormTimeZoneErrors() {
      let errors = this.validatorStep2.getErrors("timeZone");
      return errors && errors.length > 0;
    },
  },
  methods: {
    updatePhone(data) {
      this.phone = data.e164;
    },
    process(evt) {
      evt.preventDefault();
      if (this.view === "LOGIN") {
        this.loginFormStep1();
      }
      if (this.view === "REGISTER") {
        this.registerFormStep2();
      }
    },
    showLogin() {
      this.view = "LOGIN";
    },
    showRegister() {
      this.view = "REGISTER";
    },
    openModal() {
      this.$bvModal.show("modal-login");
    },
    initRememberMe() {
      if (localStorage.checkbox && localStorage.checkbox !== "") {
        this.remember = true;
        this.email = localStorage.username;
      } else {
        this.remember = false;
        this.email = "";
      }
    },
    rememberMe() {
      if (this.remember && this.email !== "") {
        localStorage.username = this.email;
        localStorage.checkbox = this.remember;
      } else {
        localStorage.username = "";
        localStorage.checkbox = "";
      }
    },
    notFirst() {
      this.isFirstRun = false;
    },
    //Register
    checkEmail1(_email, checkEmail) {
      const EMAIL = _email.trim();
      const RULE_1 = {
        expression: !EMAIL || EMAIL === "",
        name: "email",
        msg: this.$i18n.t(
          "public.components.account.LoginModal.errors.erEmail1"
        ),
      };
      /* eslint-disable-next-line */
      const RULE_2_REGEXP = new RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
      );
      const RULE_2 = {
        expression: !RULE_2_REGEXP.test(EMAIL),
        name: "email",
        msg: this.$i18n.t(
          "public.components.account.LoginModal.errors.erEmail2"
        ),
      };
      const RULE_3 = {
        expression: checkEmail,
        name: "email",
        msg: this.$i18n.t(
          "public.components.account.LoginModal.errors.erEmail3"
        ),
      };
      this.validatorStep2.addRule(RULE_1).addRule(RULE_2).addRule(RULE_3);
      this.notFirst();
    },
    checkName(_name) {
      const NAME = _name.trim();
      const RULE_1 = {
        expression: !NAME || NAME === "",
        name: "name",
        msg: this.$i18n.t("public.components.account.LoginModal.errors.erName"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkLastname(_lastname) {
      const LASTNAME = _lastname.trim();
      const RULE_1 = {
        expression: !LASTNAME || LASTNAME === "",
        name: "lastname",
        msg: this.$i18n.t(
          "public.components.account.LoginModal.errors.erLastName"
        ),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkDocument(_document) {
      const DOCUMENT = _document.trim();
      const RULE_1 = {
        expression: !DOCUMENT || DOCUMENT === "",
        name: "document",
        msg: this.$i18n.t(
          "public.components.account.LoginModal.errors.erDocument"
        ),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkLanguage(_language) {
      const LANGUAGE = _language.trim();
      const RULE_1 = {
        expression: !LANGUAGE || LANGUAGE === "",
        name: "language",
        msg: this.$i18n.t(
          "public.components.account.LoginModal.errors.erLanguage"
        ),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkPhone(_phone) {
      const PHONE = _phone.trim();
      const RULE_1 = {
        expression: !PHONE || PHONE === "",
        name: "phone",
        msg: this.$i18n.t(
          "public.components.account.LoginModal.errors.erPhone"
        ),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkCountry(_country) {
      const COUNTRY = _country.trim();
      const RULE_1 = {
        expression: !COUNTRY || COUNTRY === "",
        name: "country",
        msg: this.$i18n.t(
          "public.components.account.LoginModal.errors.erCountry"
        ),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkAddress(_address) {
      const ADDRESS = _address.trim();
      const RULE_1 = {
        expression: !ADDRESS || ADDRESS === "",
        name: "address",
        msg: this.$i18n.t(
          "public.components.account.LoginModal.errors.erAddress"
        ),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkTimeZone(_timeZone) {
      const TIMEZONE = _timeZone.trim();
      const RULE_1 = {
        expression: !TIMEZONE || TIMEZONE === "",
        name: "timeZone",
        msg: this.$i18n.t(
          "public.components.account.LoginModal.errors.erTimeZone"
        ),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkPassword(_password) {
      const PASSWORD = _password.trim();
      const RULE_1 = {
        expression: !PASSWORD || PASSWORD === "",
        name: "password",
        msg: this.$i18n.t("public.components.account.LoginModal.pwd"),
      };
      /* eslint-disable-next-line */
      const RULE_2_REGEXP = new RegExp(
        "^(?=.*[0-9]+.*)(?=.*[a-zA-Z]+.*)[0-9a-zA-Zd@$!%*#?&.]{6,}$"
      );
      const RULE_2 = {
        expression: !RULE_2_REGEXP.test(PASSWORD),
        name: "password",
        msg: this.$i18n.t("public.components.account.LoginModal.pwd2"),
      };
      this.validator.addRule(RULE_1).addRule(RULE_2);
      this.notFirst();
    },
    checkEmail(_email) {
      const EMAIL = _email.trim();
      const RULE_1 = {
        expression: !EMAIL || EMAIL === "",
        name: "email",
        msg: this.$i18n.t(
          "public.components.account.LoginModal.errors.erEmail1"
        ),
      };
      /* eslint-disable-next-line */
      const RULE_2_REGEXP = new RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
      );
      const RULE_2 = {
        expression: !RULE_2_REGEXP.test(EMAIL),
        name: "email",
        msg: this.$i18n.t(
          "public.components.account.LoginModal.errors.erEmail2"
        ),
      };
      this.validator.addRule(RULE_1).addRule(RULE_2);
      this.notFirst();
    },
    checkFormStep2() {
      this.checkEmail1(this.email1, this.emailInUse);
    },
    checkFormStep1() {
      this.checkEmail(this.user.email);
      this.checkPassword(this.user.password);
    },
    cleanFormStep1() {
      this.user = { email: "", password: "" };
      this.validator.errors = [];
    },
    cleanFormStep2() {
      this.clearModal();
      this.validatorStep2.errors = [];
    },
    registerFormStep2() {
      this.checkFormStep2();
      if (this.validatorStep2.errors.length === 0) {
        this.register();
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t(
            "public.components.account.LoginModal.notifications.error"
          ),
          text: this.$i18n.t(
            "public.components.account.LoginModal.notifications.erUsedEmail"
          ),
          type: "danger",
        });
      }
    },
    loginFormStep1() {
      this.checkFormStep1();
      if (this.validator.errors.length === 0) {
        this.login();
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t(
            "public.components.account.LoginModal.notifications.error"
          ),
          text: this.$i18n.t(
            "public.components.account.LoginModal.notifications.erUserPwd"
          ),
          type: "danger",
        });
      }
    },
    checkLogin() {
      let authentication = localStorage.getItem("authorization");
      this.$awn.asyncBlock(
        authService.checkLogin(authentication),
        (response) => {
          if (response && response.data) {
            localStorage.setItem("type", "APP");
            if (localStorage.getItem("role") === "PATIENT") {
              this.$router.push({ name: "auth.patient.dashboard" });
            } else {
              this.$router.push({ name: "auth.professional.dashboard" });
            }
          }
        },
        (error) => {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem("authorization");
          } else if (error.response && error.response.status === 404) {
            routes.push({ name: "public.signin" });
          } else if (error.response && error.response.status === 500) {
            routes.push({ name: "public.signin" });
          } else {
            routes.push({ name: "public.signin" });
          }
        },
        ""
      );
    },
    clearModal() {
      this.email1 = "";
      this.name = "";
      this.lastname = "";
      this.document = "";
      this.language = "sp";
      this.address = "";
      this.avatar = "";
      this.filename = "";
      this.phone = "";
      this.country = "";
      this.timeZone = "Europe/Brussels";
    },
    register() {
      let self = this;

      let data = {
        email: self.email1,
        name: self.name,
        lastname: self.lastname,
        document: self.document,
        language: self.language,
        address: self.address,
        avatar: self.avatar,
        filename: self.filename,
        phone: self.phone,
        country: self.country,
        timeZone: self.timeZone,
      };

      this.$awn.asyncBlock(
        patientService.createPublic(this.professionalId, data),
        (response) => {
          if (response && response.data) {
            routes.push({ name: "public.signin" });
          } else {
            routes.push({ name: "public.signin" });
          }
        },
        (error) => {
          if (error.response && error.response.status === 401) {
            self.showAlertError = true;
            self.user.password = "";
          } else if (error.response && error.response.status === 404) {
            routes.push({ name: "public.signin" });
          } else if (error.response && error.response.status === 500) {
            routes.push({ name: "public.signin" });
          } else {
            routes.push({ name: "public.signin" });
          }
        },
        ""
      );
    },
    async findRoles(request) {
      let self = this;

      let authentication = localStorage.getItem("authorization");

      authService
        .getRoles(authentication)
        .then((response) => {
          localStorage.setItem(
            "organizationRoles",
            JSON.stringify(response.data)
          );
          self.$root.$emit("reload-user", null);
          self.$bvModal.hide("modal-login");
        })
        .catch(function (error) {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem("authorization");
          } else if (error.response && error.response.status === 404) {
            localStorage.removeItem("authorization");
          } else if (error.response && error.response.status === 500) {
            localStorage.removeItem("authorization");
          } else {
            localStorage.removeItem("authorization");
          }
        });
    },
    login() {
      let self = this;

      let data = this.user;

      if (this.$device) {
        data.device = {
          accessClientName: "",
          accessClientType: "",
          accessClientVersion: "",
          accessDeviceBrand: "",
          accessDeviceType: "",
          accessClientOsName: "",
          accessClientOsVersion: "",
          accessClientOsPlatform: "",
        };
        if (this.$device.client) {
          data.device.accessClientName = this.$device.client.name;
          data.device.accessClientType = this.$device.client.type;
          data.device.accessClientVersion = this.$device.client.version;
        }
        if (this.$device.device) {
          data.device.accessDeviceBrand = this.$device.device.brand;
          data.device.accessDeviceType = this.$device.device.type;
        }
        data.device.accessClientOsName = this.$device.os_name.name;
        data.device.accessClientOsVersion = this.$device.os_version;
        data.device.accessClientOsPlatform = this.$device.os_platform;
      }

      this.$awn.asyncBlock(
        authService.login(data),
        (response) => {
          if (response && response.data) {
            localStorage.setItem("authorization", response.data.token);
            localStorage.setItem("role", response.data.role);
            localStorage.setItem("userId", response.data.userId);
            localStorage.setItem("type", response.data.type);
            localStorage.setItem(
              "organizationId",
              response.data.organizationId
            );
            self.findRoles(response);

            utilsService.auditActivity({ action: "VIEW", module: "AUTH_LOGIN", info: response.data.userId });
          } else {
            routes.push({ name: "public.signin" });
          }
        },
        (error) => {
          if (error.response && error.response.status === 401) {
            self.showAlertError = true;
            self.user.password = "";
          } else if (error.response && error.response.status === 404) {
            routes.push({ name: "public.signin" });
          } else if (error.response && error.response.status === 500) {
            routes.push({ name: "public.signin" });
          } else {
            routes.push({ name: "public.signin" });
          }
        },
        ""
      );
    },
    getAddressData: function (addressData, placeResultData, id) {
      this.address = placeResultData.formatted_address;
      this.country = addressData.country;
      this.city = addressData.locality;
      this.postalCode = addressData.postal_code;
      this.province = addressData.administrative_area_level_1;
    },
    updateAddress(data) {
      this.address = data.newVal;
    },
    vdropzoneSuccess: function (file, response) {
      this.uuid = response.uuid;
      this.filename = response.name;
      this.getFile(this.uuid);
    },
    getFile(uuid) {
      let self = this;
      utilsService
        .getFile(uuid)
        .then((response) => {
          if (response) {
            self.defaultAvatar = false;
            self.file = response.data.data;
          } else {
            self.defaultAvatar = true;
            self.file = require("../../assets/images/user/woman_profile.jpg");
          }
        })
        .catch(function (error) {
          self.defaultAvatar = true;
          self.file = require("../../assets/images/user/woman_profile.jpg");
        });
    },
    getCheckEmail(email) {
      let self = this;

      utilsService
        .checkEmailPatientProfessional(email, this.professionalId)
        .then((response) => {
          if (response) {
            self.emailInUse = response.data;
            self.checkEmail1(this.email1, response.data);
          }
        })
        .catch(function (error) {
          if (error.response && error.response.status === 404) {
            routes.push({ name: "public.signin" });
          } else if (error.response && error.response.status === 500) {
            routes.push({ name: "public.signin" });
          } else {
            routes.push({ name: "public.signin" });
          }
        });
    },
  },
  data() {
    return {
      view: "LOGIN",
      validator: validator,
      validatorStep2: validator,
      remember: "",
      user: {
        email: "",
        password: "",
        type: "APP",
      },

      //Translations phone
      translations: {
        countrySelectorLabel: this.$i18n.t(
          "generic.phone.countrySelectorLabel"
        ),
        countrySelectorError: this.$i18n.t(
          "generic.phone.countrySelectorError"
        ),
        phoneNumberLabel: this.$i18n.t("generic.phone.phoneNumberLabel"),
        example: this.$i18n.t("generic.phone.example"),
      },

      file: require("../../assets/images/user/woman_profile.jpg"),
      defaultAvatar: true,

      emailInUse: false,
      disabled: false,

      id: "",
      name: "",
      email1: "",
      name: "",
      lastname: "",
      document: "",
      language: "",
      address: "",
      phone: "",
      phoneVuePhoneNumberInput: "",
      country: "",
      timeZone: "",
      avatar: "",
      filename: "",

      //Load select
      timeZoneSelect: TimeZone,
      languageSelect: Language,

      //Form image
      dropzoneOptions: {
        url: process.env.VUE_APP_BASE_URL_CORE + "public/file/upload",
        thumbnailWidth: 200,
        maxFilesize: 2,
        addRemoveLinks: true,
        maxFiles: 1,
        dictDefaultMessage: "<i class='ri-upload-cloud-fill'></i>Subir",
      },
    };
  },
  components: {
    "vue-dropzone": vue2Dropzone,
    VuePhoneNumberInput,
  },
};
</script>